
import { Component, Prop, Vue } from "vue-property-decorator";

const CLASS = "widget-template";
const HEADLINE_CLASS = "widget-template-headline";

const ALIGN_LEFT = "left";
const ALIGN_CENTER = "center";
const ALIGN_RIGHT = "right";
const ALIGNS = [ALIGN_LEFT, ALIGN_CENTER, ALIGN_RIGHT];

const TYPE_DEFAULT = "default";
const TYPE_WARNING = "warning";
const TYPE_ERROR = "error";
const TYPES = [TYPE_DEFAULT, TYPE_WARNING, TYPE_ERROR];

const TOP_ICON_POSITION = "icon-top";
const LEFT_ICON_POSITION = "icon-left";
const ICON_POSITIONS = [TOP_ICON_POSITION, LEFT_ICON_POSITION];

const MIN_HEIGHT_DETECT_LIMITER = 200;
const IMAGE_DETECT_LIMITER_GAP = 20;
const MIN_SQUARE_IMAGE_SIZE = "240px";

@Component
export default class WidgetTemplate extends Vue {
  @Prop({ type: String }) readonly title?: string;
  @Prop({ type: String }) readonly subtitle?: string;

  @Prop({
    type: String,
    validator: (value: string) => TYPES.includes(value),
    default: TYPE_DEFAULT,
  })
  readonly type?: string;

  @Prop({
    type: String,
    validator: (value: string) => ALIGNS.includes(value),
    default: ALIGN_LEFT,
  })
  readonly align?: string;

  @Prop({ type: String }) readonly image?: string;
  @Prop({ type: String }) readonly backgroundImage?: string;

  @Prop({ type: String }) readonly iconImage?: string;
  @Prop({
    type: String,
    validator: (value: string) => {
      return ICON_POSITIONS.indexOf(value) !== -1;
    },
    default: TOP_ICON_POSITION,
  })
  readonly iconPosition?: string;

  get hasTitleSlot() {
    return !!this.$slots.title;
  }

  get hasSubtitleSlot() {
    return !!this.$slots.subtitle;
  }

  get hasDefaultSlot() {
    return !!this.$slots.default;
  }

  get hasControlsSlot() {
    return !!this.$slots.controls;
  }

  get classes() {
    const { align, type } = this;

    return {
      [`${CLASS}_${align}`]: !!align,
      [`${CLASS}_${type}`]: !!type,
    };
  }

  get headlineClasses() {
    const { iconPosition } = this;

    return {
      [`${HEADLINE_CLASS}_${iconPosition}`]: !!iconPosition,
    };
  }

  detectSquareImage() {
    const img = this.$el.querySelector(".widget-template-img__src") as HTMLImageElement;

    if (!img) return;

    if (
      img.clientHeight < MIN_HEIGHT_DETECT_LIMITER ||
      img.naturalHeight < img.naturalWidth + IMAGE_DETECT_LIMITER_GAP
    ) {
      img.style.minWidth = MIN_SQUARE_IMAGE_SIZE;
      img.style.minHeight = MIN_SQUARE_IMAGE_SIZE;

      const wrapper = this.$el.querySelector(".widget-template-img") as HTMLElement;

      if (!wrapper) return;

      return (wrapper.style.minWidth = MIN_SQUARE_IMAGE_SIZE);
    }
  }

  mounted() {
    this.detectSquareImage();
  }
}
